import { useDispatch } from 'react-redux';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { FaFilePdf } from 'react-icons/fa6';
import { IoMdCloudUpload } from 'react-icons/io';
import swal from 'sweetalert';

import { fetchDeleteResultadosValoresFiles } from '../../../redux/Evaluaciones/EvaluacionesSlice';

export const VerListaArchivosModal = ({
  estado,
  cargaArchivosEnabled,
  setCargaArchivosEnabled,
  setUploadFilesPDF,
  setPdfViewEnabled,
  validatioUserLoginServidor,
  validatioUserLoginEvaluador,
}) => {
  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // * DESESTRUCTURACION DE DATOS.
  const { logroMeta } = cargaArchivosEnabled ?? {};
  const files = Array.isArray(cargaArchivosEnabled?.files) ? cargaArchivosEnabled.files.filter(Boolean) : [];
  const archivoDisponible = (item) => typeof item?.file === 'string' && item.file.trim().length > 0;

  // * FUNCION PARA ABRIR EL MODAL DEL PDF
  const openPDFView = (item) => {
    if (!archivoDisponible(item)) {
      swal('Archivo no disponible', 'No fue posible encontrar el archivo PDF de esta evidencia.', 'error');
      return;
    }

    setPdfViewEnabled({ enabled: true, file: { link: item.file, nombre: item.nombreArchivo } });
  };

  // * FUNCION PARA ELIMINAR UN ARCHIVO DE EVIDENCIA
  const deleteEvidencia = (item) => {
    swal({
      title: `Estás seguro de eliminar la evidencia ${item.nombreArchivo}?`,
      text: 'Una vez eliminado el archivo, no será posible recuperarlo.',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((answer) => {
      if (answer) {
        dispatch(fetchDeleteResultadosValoresFiles(item.id));
      }
    });
  };

  // * FUNCION PARA CARGAR ARCHIVOS
  const openFilesUpload = () => {
    if (files.length >= 5) {
      swal('Error', 'Has alcanzado el límite máximo de evidencias permitidas (5).', 'error');
      return;
    }

    setUploadFilesPDF(true);
  };

  return (
    <Dialog PaperProps={{ sx: { width: '50%', height: '60%' } }} open={!!cargaArchivosEnabled?.enabled} maxWidth="lg">
      <DialogTitle sx={{ textTransform: 'uppercase' }} className="text-mem text-center">
        Evidencias de logro de meta: <br /> <b>{logroMeta}</b>
      </DialogTitle>
      <Divider />

      <DialogContent>
        <Paper sx={{ mb: 2 }} elevation={3}>
          <TableContainer>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell width="75%" sx={{ fontWeight: 'bold' }}>
                    Archivo
                  </TableCell>

                  <TableCell align="right">
                    {estado !== 2 &&
                      (validatioUserLoginServidor || validatioUserLoginEvaluador) && (
                        <button
                          type="button"
                          className="btn btn-primary-mem"
                          onClick={() => openFilesUpload()}
                        >
                          Cargar
                          <IoMdCloudUpload
                            style={{ marginBottom: 1 }}
                            fontSize={22}
                            className="ms-1"
                          />
                        </button>
                      )}
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {files.length > 0 ? (
                  files.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {item.nombreArchivo ?? 'Archivo sin nombre'}
                        {!archivoDisponible(item) && <Typography variant="caption" color="error" display="block">Archivo no disponible</Typography>}
                      </TableCell>
                      <TableCell className="d-flex justify-content-end">
                        <IconButton
                          title={archivoDisponible(item) ? 'Ver PDF' : 'Archivo no disponible'}
                          onClick={() => openPDFView(item)}
                          style={{ color: archivoDisponible(item) ? '#C72924' : '#777777' }}
                        >
                          <FaFilePdf />
                        </IconButton>
                        <IconButton hidden={estado === 2} onClick={() => deleteEvidencia(item)} style={{ color: '#C72924' }}>
                          <DeleteForeverIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography>No hay registros</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </DialogContent>

      <DialogActions className="justify-content-center">
        <button type="button" onClick={() => setCargaArchivosEnabled({ ...cargaArchivosEnabled, enabled: false })} className="btn btn-primary">
          <ArrowBackIcon sx={{ marginTop: -0.5, marginRight: 0.5 }} />
          Volver
        </button>
      </DialogActions>
    </Dialog>
  );
};
